// resources/js/src/components/community/components/post/FacebookPost.tsx
import React, { useState } from "react";
import PostHeader from "./components/PostHeader";
import PostContent from "./components/PostContent";
import PostMedia from "./components/PostMedia";
import PostActions from "./components/PostActions";
import PostStats from "./components/PostStats";
import Lightbox from "./components/Lightbox";
import { CommunityPost } from "./interfaces/post.interface";
import { ReactionType } from "./interfaces/types";
import { createPostStore, usePostStore } from "../../../../store/postStore";

type Props = {
  post: CommunityPost;
  useStore: ReturnType<typeof createPostStore>; // ← بدل mode
  onEdit?: (post: CommunityPost) => void;
  onDelete?: (post: CommunityPost) => void;
};

const FacebookPost: React.FC<Props> = ({ post, useStore, onEdit, onDelete }) => {

  const [lightbox, setLightbox] = useState<string | null>(null);

  // ✅ Reactions من الـ store (مصدر الحقيقة)
  const { reactToPost } = useStore();

  const handleReact = async (r: ReactionType) => {
    await reactToPost(post.id, r);
  };
  
  return (
    <>
      <div className="p-4 bg-white dark:bg-deepSlate rounded-lg shadow mx-auto mb-4">
        <PostHeader
          userName={post.author.name}
          userAvatar={post.author.avatarUrl}
          userId={post.author.id}
          createdAt={post.createdAt}
          isOwner={post.isOwner}
          onEdit={() => onEdit?.(post)}
          onDelete={() => onDelete?.(post)}
        />

        {post.body && <PostContent content={post.body} />}

        {post.media && post.media.length > 0 && (
          <PostMedia mediaFiles={post.media} onOpen={setLightbox} />
        )}

        {/* ✅ Stats */}
        <PostStats
          postId={post.id}
          likes={post.reactionsCount ?? 0}
          commentsCount={post.commentsCount ?? 0}
          reactions={post.reactions ?? []}
        />

        {/* ✅ Actions */}
        <PostActions
          postId={post.id}
          reaction={post.myReaction ?? null}
          onReact={handleReact}
        />
      </div>

      <Lightbox img={lightbox} onClose={() => setLightbox(null)} />
    </>
  );
};

export default React.memo(FacebookPost);